// Browser detection utility
export const getBrowserInfo = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const browserInfo = {
    name: 'unknown',
    version: 'unknown',
    isMobile: false,
    supports2FA: true
  };

  // Detect browser name and version
  if (userAgent.includes('firefox')) {
    browserInfo.name = 'firefox';
    browserInfo.version = userAgent.match(/firefox\/(\d+)/)?.[1] || 'unknown';
  } else if (userAgent.includes('chrome') && !userAgent.includes('edg')) {
    browserInfo.name = 'chrome';
    browserInfo.version = userAgent.match(/chrome\/(\d+)/)?.[1] || 'unknown';
  } else if (userAgent.includes('safari') && !userAgent.includes('chrome')) {
    browserInfo.name = 'safari';
    browserInfo.version = userAgent.match(/version\/(\d+)/)?.[1] || 'unknown';
  } else if (userAgent.includes('edg')) {
    browserInfo.name = 'edge';
    browserInfo.version = userAgent.match(/edg\/(\d+)/)?.[1] || 'unknown';
  } else if (userAgent.includes('opera') || userAgent.includes('opr')) {
    browserInfo.name = 'opera';
    browserInfo.version = userAgent.match(/(?:opera|opr)\/(\d+)/)?.[1] || 'unknown';
  }

  // Detect mobile
  const mobileRegex = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  browserInfo.isMobile = mobileRegex.test(navigator.userAgent);

  // Determine 2FA support
  // Some older browsers or mobile browsers might have issues with 2FA
  const minVersion = {
    chrome: 60,
    firefox: 60,
    safari: 12,
    edge: 79,
    opera: 50
  };

  if (browserInfo.name in minVersion) {
    browserInfo.supports2FA = parseInt(browserInfo.version) >= minVersion[browserInfo.name];
  }

  return browserInfo;
};

export const is2FASupported = () => {
  const browserInfo = getBrowserInfo();
  return browserInfo.supports2FA;
}; 